// src/pages/Home.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Home = () => {
   const { articles, loading } = useData();
   const [isOpen, setIsOpen] = useState(false);

   if (loading) {
      return <div className="p-8">Загрузка новостей из Google Sheets...</div>;
   }

   if (articles.length === 0) {
      return <div className="p-8">Пока нет новостей</div>;
   }

   // Главная новость — первый элемент
   const [mainArticle, ...restArticles] = articles;

   return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
         {/* --- Хероблок: главная новость --- */}
         <section className="mb-12">
            <div className="relative h-[600px]">
               {/* Устанавливаем фиксированную высоту через h-64 (256px).
              Можно взять h-72 (288px) или h-80 (320px) по вашему вкусу. */}
               <img
                  src={mainArticle.ImageUrl || "https://via.placeholder.com/1200x600"}
                  alt={mainArticle.Title}
                  className="w-full h-full object-contain rounded-lg shadow"
               />
               <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 text-sm font-semibold rounded-full">
                  Басты жаңалық
               </div>
            </div>

            {/* Текстовое описание, заголовок и ссылка */}
            <div className="mt-4">
               <div className="flex flex-wrap gap-2 mb-2">
                  <span className="bg-gray-200 text-gray-700 px-2 py-1 text-sm rounded">
                     {mainArticle.Category || "Без категории"}
                  </span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-1 text-sm rounded">
                     Автор: {mainArticle.Author || "Белгісіз"}
                  </span>
               </div>
               <h3 className="text-2xl md:text-3xl font-bold mb-2">{mainArticle.Title}</h3>
               <div className="text-gray-500 text-sm mb-2">{mainArticle.Date} &mdash; 6 минут чтения</div>
               <p className="text-gray-700 mb-2">
                  {/* Можно вывести короткий анонс или часть контента */}
                  {mainArticle.Title}
               </p>
               <Link to={`/news/${mainArticle.ID}`} className="text-blue-600 font-semibold hover:underline">
                  Мақаланы оқу
               </Link>
            </div>
         </section>

         {/* --- Остальные новости --- */}
         <section>
            <div className="flex items-center justify-between mb-4">
               <h2 className="text-xl font-bold">Соңғы жаңалықтар</h2>
               <button
                  onClick={() => {
                     setIsOpen(!isOpen);
                  }}
                  className="text-sm text-blue-600 hover:underline"
               >
                  Барлық жаңалықтар
               </button>
            </div>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
               {restArticles.map((art, index) => {
                  if (!isOpen && index > 7) {
                     return;
                  }
                  return <NewsCard key={art.ID} article={art} />;
               })}
            </div>
         </section>
      </div>
   );
};

function NewsCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Home;
